import { Switch } from "@/components/ui/switch";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import SpiceSelector from "@/components/lib/SpiceSelector";
import CreateAllergenDialog from "@/components/dialog/menu-manage/common-dialog/create-allergen";
import CreateAddonsDialog from "@/components/dialog/menu-manage/common-dialog/create-addons";
import { spiceLevels } from "@/assets/constans";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ButtonType } from "@/components/lib/Button";

function Step2({ form, fishChips_id, item_id }) {
  const allergen_ids = form.watch("allergen_ids");
  const add_on_ids = form.watch("add_on_ids");
  const in_price = form.watch("in_price");
  const out_price = form.watch("out_price");
  const spice_level = form.watch("spice_level");
  const [showAllergen, setShowAllergens] = useState(false);
  const [createNewAllergen, setCreateNewAllergen] = useState(false);
  const [createNewAddOn, setCreateNewAddOn] = useState(false);
  const [showSpice, setShowSpice] = useState(false);
  const [showInprice, setShowInprice] = useState(false);
  const [showOutprice, setShowOutprice] = useState(false);
  const [showAddOns, setShowAddOns] = useState(false);
  const { allergens } = useSelector((state) => state.essentialMenu.allergens);
  const { addOns } = useSelector((state) => state.essentialMenu.addOns);

  const closeNewAllergen = () => {
    setCreateNewAllergen(false);
  };

  useEffect(() => {
    setShowAllergens(Array.isArray(allergen_ids) && allergen_ids.length > 0);
    setShowAddOns(Array.isArray(add_on_ids) && add_on_ids.length > 0);
    setShowInprice(!!in_price);
    setShowOutprice(!!out_price);
    setShowSpice(!!spice_level);
  }, [allergen_ids, add_on_ids, in_price, out_price, spice_level]);

  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {" "}
          {form.watch("type") == "update"
            ? "Update Fish and Chips"
            : "Add New Fish and Chips  "}
        </CardTitle>
        <CardDescription className="text-cyellow">
          Item name: {form.watch("name") || "No name"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-8 mt-5">
          <FormInputField
            name="size"
            style="bg-cblack7"
            placeholder={"Size"}
            form={form}
            label={"Size"}
            type="text"
          />
          <div className="space-y-2">
            <div className="flex gap-2 items-center">
              <Switch
                checked={showInprice}
                onCheckedChange={(val) => {
                  setShowInprice(val);
                }}
              />
              <Label>In Price</Label>
            </div>
            {showInprice && (
              <FormInputField
                name="in_price"
                style="bg-cblack7"
                placeholder={"00"}
                form={form}
                type="text"
              />
            )}
          </div>
          <div className="space-y-2">
            <div className="flex gap-2 items-center">
              <Switch
                checked={showOutprice}
                onCheckedChange={(val) => {
                  setShowOutprice(val);
                }}
              />
              <Label>Out Price</Label>
            </div>
            {showOutprice && (
              <FormInputField
                name="out_price"
                style="bg-cblack7"
                placeholder={"00"}
                form={form}
                type="text"
              />
            )}
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <div className="flex gap-2 items-center">
                  <Switch
                    checked={showAddOns}
                    onCheckedChange={(val) => {
                      setShowAddOns(val);
                    }}
                  />
                  <Label>Add Ons</Label>
                </div>
                {showAddOns && (
                  <div className="space-y-2 flex mt-2 w-full">
                    <FormInputField
                      name="add_on_ids"
                      style="bg-cblack7 flex-1"
                      placeholder={"Select Add Ons"}
                      form={form}
                      type="multiselect"
                      label={"Add ons"}
                      selectOption={
                        addOns && addOns?.length > 0
                          ? addOns
                            .filter((item) => item?.status === "active")
                            .map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))
                          : [
                              {
                                label: "No brand available",
                                value: "",
                                disabled: true,
                              },
                            ]
                      }
                    />
                  </div>
                )}
              </div>
              {showAddOns && (
                <ButtonType onClick={() => setCreateNewAddOn(true)}>
                  Create New Add Ons
                </ButtonType>
              )}
              <CreateAddonsDialog
                menu_id={fishChips_id}
                title={"Create New Add Ons"}
                onClose={() => setCreateNewAddOn(false)}
                isOpen={createNewAddOn}
              />
            </div>
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <div className="flex gap-2 items-center">
                  <Switch
                    checked={showAllergen}
                    onCheckedChange={(val) => {
                      setShowAllergens(val);
                      if (!val) {
                        form.setValue("allergen_ids", []);
                      }
                    }}
                  />
                  <Label>Allergen</Label>
                </div>
                {showAllergen && (
                  <div className="space-y-2 flex mt-2 w-full">
                    <FormInputField
                      name="allergen_ids"
                      style="bg-cblack7 flex-1"
                      placeholder={"Select Allergens"}
                      form={form}
                      type="multiselect"
                      label={"Allergens"}
                      selectOption={
                        allergens && allergens?.length > 0
                          ? allergens
                            .filter((item) => item?.status === "active")
                            .map((item) => ({
                              label:
                                item.name +
                                (item?.short_name ? ` (${item.short_name})` : ""),
                              value: item.id,
                            }))
                          : [
                              {
                                label: "Not available",
                                value: "",
                                disabled: true,
                              },
                            ]
                      }
                    />
                  </div>
                )}
              </div>
              {showAllergen && (
                <ButtonType onClick={() => setCreateNewAllergen(true)}>
                  Create New Allergen
                </ButtonType>
              )}
              <CreateAllergenDialog
                menu_id={fishChips_id}
                title={"Create New Allergen"}
                onClose={closeNewAllergen}
                isOpen={createNewAllergen}
              />
            </div>
          </div>
          <div>
            <div className="flex gap-5 justify-between items-end ">
              <div className="w-full">
                <SpiceSelector form={form} />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default Step2;
